(function (loginSetting, $) {

    /* Initialize the Login analysis datatable */
    loginSetting.InitLoginAnalysisGrid = function(subscriptionKey, loginSettingKey) {
        $("#loginAnalysisGrid").DataTable(datatable.defaultDataTableOptions( {
            ajax: {
                url: '/Rap/SearchLoginAnalysis?subscriptionKey=' + globalCore.urlEncode(subscriptionKey) + '&loginSettingKey=' + globalCore.urlEncode(loginSettingKey)
            },
            columns: [
                { data: "recipient", name: "Recipient", title: "E-mailadres", orderable: true, searchable: true },
                { data: "creationDate", name: "CreationDate", title: "Aanmaakdatum", defaultContent: '', orderable: true, searchable: false },
                { data: "lastLoginDate", name: "LastLoginDate", title: "Logindatum", defaultContent: '',  orderable: true, searchable: false },
                { responsivePriority: -1, defaultContent: "", orderable: false, searchable: false }
            ],
            columnDefs: [
                {
                  targets: [1, 2],
                  render: function(data, type, full, meta) {
                      return datatable.dutchDateFormat(data, "DD-MM-YYYY HH:mm");
                  }
                },
                {
                    targets: -1,
                    width: '125px',
                    fixed: true,
                    render: function (data, type, full, meta) {
                        return '<a href="/Rap/LoginDetails?subscriptionKey=' + globalCore.urlEncode(subscriptionKey) + '&loginSettingKey=' + globalCore.urlEncode(loginSettingKey) + '&loginAnalysisKey=' + globalCore.urlEncode(full.key) + '" class="btn btn-outline-primary fas fa-eye" title="Login details bekijken" data-bs-toggle="modal" data-bs-target="#modalcontainer"></a>';
                    }
                }
            ]
        }));
    }

    loginSetting.Init = function () {
        initFieldVisibility($("[data-logintype]").val());

        $(document).on("change", "[data-logintype]", function () {
            initFieldVisibility(this.value);
        });

        function initFieldVisibility(selectedValue) {
            if (selectedValue == 0) {
                // None
                $('[data-metadata]').hide();
                $('[data-clientsecretid]').hide();
                $('[data-clientid]').hide();
            }
            else if (selectedValue == 1) {
                // ADFS
                $('[data-metadata]').show();
                $('[data-clientsecretid]').hide();
                $('[data-clientid]').show();
            }
            else if (selectedValue == 2) {
                // AzureAD
                $('[data-metadata]').show();
                $('[data-clientsecretid]').hide();
                $('[data-clientid]').show();
            }
            else if (selectedValue == 3) {
                // Google
                $('[data-metadata]').hide();
                $('[data-clientsecretid]').show();
                $('[data-clientid]').show();
            }
        }
    }
}(window.loginSetting = window.loginSetting || {}, jQuery));

